module.exports = __webpack_public_path__ + "static/media/group.63f5c8a7.png";